export default __webpack_public_path__ + "static/media/img_13.77baff44.jpg";